/* Showrz — scripts du thème (menu mobile, galerie, variantes, packs, panier en tiroir). */
(function () {
  const fmt = (cents) => {
    const devise = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR';
    const langue = document.documentElement.lang || 'fr';
    const entier = cents % 100 === 0;
    try {
      return new Intl.NumberFormat(langue, { style: 'currency', currency: devise, minimumFractionDigits: entier ? 0 : 2, maximumFractionDigits: entier ? 0 : 2 }).format(cents / 100);
    } catch (e) {
      const v = (cents / 100).toFixed(2).replace('.', ',');
      return (v.endsWith(',00') ? v.slice(0, -3) : v) + ' ' + devise;
    }
  };

  // Menu mobile
  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-burger]');
    if (!b) return;
    const nav = document.querySelector('.sz-nav');
    const open = nav.classList.toggle('is-open');
    b.setAttribute('aria-expanded', open);
  });

  // Galerie produit
  document.querySelectorAll('[data-gallery]').forEach((g) => {
    const main = g.querySelector('[data-gallery-main]');
    g.querySelectorAll('[data-thumb]').forEach((t) => {
      t.addEventListener('click', () => {
        main.src = t.dataset.src;
        main.srcset = '';
        main.alt = t.dataset.alt || '';
        g.querySelectorAll('[data-thumb]').forEach((x) => x.setAttribute('aria-current', 'false'));
        t.setAttribute('aria-current', 'true');
      });
    });
  });

  // Formulaire produit : variantes, packs, abonnement
  document.querySelectorAll('[data-product-form]').forEach((form) => {
    const data = JSON.parse(form.querySelector('[data-variants]').textContent);
    const idInput = form.querySelector('[name="id"]');
    const priceEl = form.closest('[data-product]').querySelector('[data-price]');
    const compareEl = form.closest('[data-product]').querySelector('[data-compare]');
    const btn = form.querySelector('[data-add]');
    const nameEl = form.closest('[data-product]').querySelector('[data-option-value]');
    const main = form.closest('[data-product]').querySelector('[data-gallery-main]');

    const current = () => {
      const opts = [...form.querySelectorAll('[data-option]')].map((fs) => {
        const c = fs.querySelector('input:checked');
        return c ? c.value : null;
      });
      return data.find((v) => v.options.every((o, i) => opts[i] === null || o === opts[i]));
    };
    const update = () => {
      const v = current();
      if (!v) return;
      idInput.value = v.id;
      if (priceEl) priceEl.textContent = fmt(v.price);
      if (compareEl) compareEl.textContent = v.compare_at_price > v.price ? fmt(v.compare_at_price) : '';
      if (btn) {
        btn.disabled = !v.available;
        btn.textContent = v.available ? btn.dataset.label : ((window.SZ.t || {}).epuise || 'Épuisé');
      }
      if (nameEl) nameEl.textContent = v.options[0];
      if (main && v.featured_image) {
        main.src = v.featured_image;
        main.srcset = '';
      }
      const url = new URL(window.location.href);
      url.searchParams.set('variant', v.id);
      window.history.replaceState({}, '', url);
    };
    form.addEventListener('change', (e) => {
      if (e.target.closest('[data-option]')) update();
      if (e.target.name === 'pack') {
        const pv = e.target.value;
        idInput.value = pv;
      }
    });
    form.querySelectorAll('[data-qty]').forEach((q) => {
      const input = q.querySelector('input');
      q.querySelector('[data-minus]').onclick = () => (input.value = Math.max(1, +input.value - 1));
      q.querySelector('[data-plus]').onclick = () => (input.value = +input.value + 1);
    });
    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      if (btn.classList.contains('is-charge')) return;
      const libelle = btn.textContent;
      btn.classList.add('is-charge');
      btn.setAttribute('aria-busy', 'true');
      btn.textContent = (window.SZ.t || {}).ajout || 'Ajout…';
      const body = new FormData(form);
      try {
        const r = await fetch(window.SZ.routes.cart_add + '.js', { method: 'POST', body, headers: { Accept: 'application/json' } });
        if (!r.ok) throw new Error((await r.json()).description || 'Erreur');
        btn.textContent = (window.SZ.t || {}).ajoute || '✓ Ajouté';
        await openCart();
      } catch (err) {
        alertMsg(form, err.message);
      } finally {
        btn.classList.remove('is-charge');
        btn.removeAttribute('aria-busy');
        btn.textContent = libelle;
      }
    });
  });

  function alertMsg(form, msg) {
    let el = form.querySelector('.sz-erreur');
    if (!el) {
      el = document.createElement('p');
      el.className = 'sz-erreur';
      el.setAttribute('role', 'alert');
      form.appendChild(el);
    }
    el.textContent = msg;
  }

  // Tiroir panier
  const drawer = document.querySelector('[data-drawer]');
  async function renderCart() {
    const cart = await (await fetch(window.SZ.routes.cart + '.js')).json();
    document.querySelectorAll('[data-cart-count]').forEach((c) => (c.textContent = cart.item_count));
    if (!drawer) return cart;
    const body = drawer.querySelector('[data-drawer-body]');
    const reste = Math.max(0, window.SZ.freeShipping - cart.total_price);
    const pct = Math.min(100, Math.round((cart.total_price / window.SZ.freeShipping) * 100));
    const T = window.SZ.t || {};
    const ship = drawer.querySelector('[data-ship]');
    if (ship && window.SZ.freeShipping) {
      ship.innerHTML = reste > 0 ? (T.reste || '').replace('[montant]', fmt(reste)) : T.livraison_ok;
      drawer.querySelector('[data-ship-bar]').style.width = pct + '%';
    }
    drawer.querySelector('[data-total]').textContent = fmt(cart.total_price);
    body.innerHTML = cart.items.length
      ? cart.items.map((it, i) => `
        <div class="sz-ligne-panier">
          <img src="${it.image ? it.image.replace(/(\.[a-z]+)(\?|$)/i, '_200x$1$2') : ''}" alt="" width="80" height="100">
          <div><b>${it.product_title}</b><br><small>${it.variant_title || ''}${it.selling_plan_allocation ? ' · ' + it.selling_plan_allocation.selling_plan.name : ''}</small><br>
            <div class="sz-qty" style="margin-top:6px"><button type="button" data-line="${i + 1}" data-q="${it.quantity - 1}" aria-label="${T.moins}">−</button><input value="${it.quantity}" aria-label="${T.quantite}" readonly><button type="button" data-line="${i + 1}" data-q="${it.quantity + 1}" aria-label="${T.plus}">+</button></div></div>
          <b>${fmt(it.final_line_price)}</b>
        </div>`).join('')
      : '<p>' + T.vide + '</p>';
    renderUpsells(cart);
    return cart;
  }

  // Suggestions du panier flottant (mêmes règles que la page panier)
  function renderUpsells(cart) {
    const box = drawer && drawer.querySelector('[data-upsells]');
    const src = document.getElementById('sz-upsells');
    if (!box || !src) return;
    let produits = [];
    try { produits = JSON.parse(src.textContent); } catch (e) { return; }
    const items = cart.items || [];
    const handles = items.map((i) => i.handle);
    const aFiltre = items.some((i) => ['kit-showrz', 'douchette-filtrante', 'pack-ultime'].includes(i.handle) || (i.handle === 'recharge-filtre' && !/3/.test(i.variant_title || '')));
    const aPack3 = items.some((i) => i.handle === 'recharge-filtre' && /3/.test(i.variant_title || ''));
    const kit = items.find((i) => ['kit-showrz', 'kit-barre', 'pack-ultime'].includes(i.handle));
    const aPack = handles.includes('pack-ultime');
    const couleur = kit ? (kit.options_with_values && kit.options_with_values[0] ? kit.options_with_values[0].value : kit.variant_title) : '';
    const choix = [];
    for (const p of produits) {
      if (choix.length >= 3) break;
      let v = null;
      if (p.handle === 'recharge-filtre') {
        if (!aFiltre || aPack3) continue;
        v = p.variantes.find((x) => /3/.test(x.titre)) || p.variantes[0];
      } else {
        if (!kit || handles.includes(p.handle)) continue;
        if (aPack && ['gobelet', 'miroir', 'support-telephone'].includes(p.handle)) continue;
        v = p.variantes.find((x) => x.titre === couleur) || p.variantes[0];
      }
      if (v && v.dispo) choix.push({ p, v });
    }
    if (!choix.length) { box.innerHTML = ''; return; }
    box.innerHTML = '<p class="sz-upsells__titre">' + (window.SZ.t || {}).complete + '</p>' + choix.map(({ p, v }) => `
      <div class="sz-upsell">
        ${(v.image || p.image) ? `<img src="${v.image || p.image}" alt="" width="64" height="80" loading="lazy">` : ''}
        <div class="sz-upsell__txt"><b>${p.titre}</b><small>${v.titre !== 'Default Title' ? v.titre + ' · ' : ''}${fmt(v.prix)}</small></div>
        <button type="button" class="sz-btn sz-btn--secondaire sz-upsell__btn" data-upsell-add="${v.id}">${(window.SZ.t || {}).ajouter}</button>
      </div>`).join('');
  }
  document.addEventListener('click', async (e) => {
    const b = e.target.closest('[data-upsell-add]');
    if (!b) return;
    b.disabled = true; b.textContent = '…';
    await fetch(window.SZ.routes.cart_add + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: +b.dataset.upsellAdd, quantity: 1 }) });
    renderCart();
  });
  async function openCart() {
    if (!drawer) { window.location.href = window.SZ.routes.cart; return; }
    await renderCart();
    drawer.classList.add('is-open');
    drawer.querySelector('[data-close]').focus();
  }
  document.addEventListener('click', async (e) => {
    if (e.target.closest('[data-open-cart]')) { e.preventDefault(); openCart(); }
    if (e.target.closest('[data-close]') || e.target.matches('.sz-drawer__fond')) drawer.classList.remove('is-open');
    const q = e.target.closest('[data-line]');
    if (q) {
      await fetch(window.SZ.routes.cart_change + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ line: +q.dataset.line, quantity: Math.max(0, +q.dataset.q) }) });
      renderCart();
    }
  });
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && drawer) drawer.classList.remove('is-open'); });
})();

/* Choix de la formule : garde la couleur choisie quand on passe d'un produit à l'autre */
(function () {
  const maj = () => {
    const fs = document.querySelector('[data-product-form] [data-option] input:checked');
    if (!fs) return;
    const couleur = fs.value;
    document.querySelectorAll('[data-formule]').forEach((a) => {
      try { const u = JSON.parse(a.dataset.urls); if (u[couleur]) a.href = u[couleur]; } catch (e) {}
    });
  };
  document.addEventListener('change', (e) => { if (e.target.closest('[data-option]')) maj(); });
  maj();
})();

/* Panneau « détail du kit » */
(function () {
  const d = document.querySelector('[data-detail]');
  if (!d) return;
  document.addEventListener('click', (e) => {
    if (e.target.closest('[data-detail-open]')) {
      const main = document.querySelector('[data-gallery-main]');
      const img = d.querySelector('[data-detail-img]');
      if (main && img) { img.src = main.currentSrc || main.src; img.removeAttribute('srcset'); }
      if (d.showModal) d.showModal(); else d.setAttribute('open', '');
    }
    if (e.target.closest('[data-detail-close]') || e.target === d) d.close ? d.close() : d.removeAttribute('open');
  });
})();

/* Formules : défilement horizontal avec flèches */
(function () {
  document.querySelectorAll('[data-formules]').forEach((box) => {
    const l = box.querySelector('[data-f-liste]');
    const prev = box.querySelector('[data-f-prev]'), next = box.querySelector('[data-f-next]');
    if (!l) return;
    const pas = () => (l.querySelector('.sz-formule') || {}).offsetWidth + 10 || 160;
    const etat = () => { prev.disabled = l.scrollLeft < 4; next.disabled = l.scrollLeft + l.clientWidth >= l.scrollWidth - 4; };
    prev.addEventListener('click', () => l.scrollBy({ left: -pas(), behavior: 'smooth' }));
    next.addEventListener('click', () => l.scrollBy({ left: pas(), behavior: 'smooth' }));
    l.addEventListener('scroll', etat, { passive: true });
    const on = l.querySelector('.is-on');
    if (on) l.scrollLeft = Math.max(0, on.offsetLeft - l.offsetLeft - 16);
    etat();
    // Lien « Formules dès … » : descend jusqu'aux formules et montre la moins chère
    document.querySelectorAll('[data-des]').forEach((a) => a.addEventListener('click', (e) => {
      e.preventDefault();
      box.scrollIntoView({ behavior: 'smooth', block: 'center' });
      l.scrollTo({ left: 0, behavior: 'smooth' });
    }));
  });
})();

/* Collections : filtre par couleur */
(function () {
  const g = document.querySelector('[data-coll-grille]');
  if (!g) return;
  const vide = document.querySelector('[data-coll-vide]');
  const filtrer = (c) => {
    let n = 0;
    g.classList.toggle('is-filtre', !!c);
    g.querySelectorAll('.sz-carte').forEach((el) => {
      const ok = !c || el.dataset.couleur === c || (el.dataset.couleurs || '').includes('|' + c + '|');
      el.classList.toggle('is-cache', !ok);
      if (ok) n++;
    });
    if (vide) vide.hidden = n > 0;
    document.querySelectorAll('[data-couleur-filtre]').forEach((b) => b.classList.toggle('is-on', b.dataset.couleurFiltre === c && b.classList.contains('sz-chip')));
  };
  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-couleur-filtre]');
    if (!b) return;
    filtrer(b.dataset.couleurFiltre);
    const u = new URL(location.href);
    if (b.dataset.couleurFiltre) u.searchParams.set('couleur', b.dataset.couleurFiltre); else u.searchParams.delete('couleur');
    history.replaceState({}, '', u);
  });
  const init = new URL(location.href).searchParams.get('couleur');
  if (init) filtrer(init);
})();

/* Jeu de texte : le mot couleur qui change tout seul */
(function () {
  const COUL = {Rose:'#F7A8C4',Lilas:'#CDBDF5',Beurre:'#F6D55C','Forêt':'#1F5C45',Cerise:'#C8102E',Cobalt:'#7C8CFF','Noir mat':'#1C1C1C',Mandarine:'#FF7A3D',Beige:'#D8C3A5',Pink:'#F7A8C4',Lilac:'#CDBDF5',Butter:'#F6D55C',Forest:'#1F5C45',Cherry:'#C8102E','Matte Black':'#1C1C1C',Tangerine:'#FF7A3D'};
  document.querySelectorAll('[data-tourne]').forEach((el) => {
    let mots = []; try { mots = JSON.parse(el.dataset.tourne); } catch (e) { return; }
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    let i = 0;
    setInterval(() => {
      i = (i + 1) % mots.length;
      el.textContent = mots[i];
      el.style.color = COUL[mots[i]] || '';
      el.classList.remove('pop'); void el.offsetWidth; el.classList.add('pop');
    }, 1400);
  });
})();
